import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postVerificationProfile } from '../requests';
import type { SubmitVerificationProfileRequestDto } from '../types';
import { useSessionStore } from '@/entities/session';

const useVerificationProfileSubmit = () => {
  const queryClient = useQueryClient();
  const { session } = useSessionStore();

  const mutation = useMutation({
    mutationFn: (data: SubmitVerificationProfileRequestDto) => {
      return postVerificationProfile(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-verification-profile', session?.userId],
      });

      queryClient.invalidateQueries({
        queryKey: ['user-verification-info', session?.userId],
      });
    },
  });

  return {
    submitVerificationProfile: mutation.mutateAsync,
    submitResult: mutation.data,
    isSubmitVerificationProfileLoading: mutation.isPending,
    isSubmitVerificationProfileSuccess: mutation.isSuccess,
    isSubmitVerificationProfileError: mutation.isError,
    submitVerificationProfileError: mutation.error,
  };
};

export { useVerificationProfileSubmit };
